<template>
    <album v-if="renderAlbum"/>
</template>

<script>
  import Album from '../components/Album.vue';

  import album from 'src/mixins/albumPage';

  export default {
    mixins: [album],
    components: {
      Album,
    },
  };
</script>